import classNames from 'class-names';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import Icon from '../../../Atoms/Icon/Icon';

import Content from './Content';
import styles from './wan.module.css';

const NUMBER_OF_BARS = 4;

const simIcon = ({ enabled, active }) => {
  if (active) return 'sim';
  if (!enabled) return 'sim-disabled';

  return 'sim-outline';
};

const simClass = ({ enabled, active }) => {
  if (active) return 'text-success';
  if (!active && enabled) return 'text-success';

  return 'text-gray';
};

const signalIcons = [
  'signal-thick-0',
  'signal-thick-1',
  'signal-thick-2',
  'signal-thick-3',
  'signal-thick',
];

export const signalIcon = (signalStrengthNormalized) => {
  const signalLines = Math.ceil(
    (NUMBER_OF_BARS / 100) * signalStrengthNormalized,
  );

  return signalIcons[signalLines] || signalIcons[0];
};

const Cell = ({
  connectionStatus,
  active,
  enabled,
  operatorName,
  signalStrengthNormalized,
  dataCapability,
  simName,
  children,
}) => {
  const child = children && children.find((node) => node.key === 'cell');

  return (
    <Row>
      <Col xs={6} xl={2}>
        <Content
          icon={
            <Icon
              className={classNames('text-primary', styles.iconXl)}
              name={signalIcon(signalStrengthNormalized)}
              role="status"
            />
          }
          line1={connectionStatus || '---'}
          line1ClassName="text-gray-500 text-uppercase"
          line2ClassName={classNames({
            'text-gray-500': !connectionStatus,
          })}
        />
      </Col>

      <Col xs={6} xl={2}>
        <Content
          icon={<Icon className={styles.iconMd} role="status" name="carrier" />}
          line1="Carrier"
          line2={operatorName || '---'}
          line2ClassName={operatorName ? 'text-blue-dark' : 'text-gray-500'}
        />
      </Col>

      <Col xs={6} xl={2}>
        <Content
          icon={
            <Icon className={styles.iconMd} name="broadcast" role="status" />
          }
          line1="Service"
          line2={dataCapability || '---'}
          line2ClassName={classNames(
            'text-uppercase',
            dataCapability ? 'text-blue-dark' : 'text-gray-500',
          )}
        />
      </Col>

      <Col xs={6} xl={2}>
        <Content
          icon={
            <Icon
              className={classNames(
                simClass({ active, enabled }),
                styles.iconMd,
              )}
              name={simIcon({ active, enabled })}
              role="status"
            />
          }
          line1="SIM Card"
          line2={simName || '---'}
          line2ClassName="text-gray-500"
        />
      </Col>

      <Col className="col pt-3 pb-5 py-sm-0 text-center text-xl-right">
        {child}
      </Col>
    </Row>
  );
};

Cell.propTypes = {
  active: PropTypes.bool,
  connectionStatus: PropTypes.string,
  dataCapability: PropTypes.string,
  enabled: PropTypes.bool,
  operatorName: PropTypes.string,
  signalStrengthNormalized: PropTypes.number,
  simName: PropTypes.string,
  children: PropTypes.node,
};

export default Cell;
